module.exports = __webpack_public_path__ + "img/Spartan-Logo.fb529934.png";